import { TextField } from "@mui/material";
import { withStyles } from "@mui/styles";

/**
 * Shared text input — use this everywhere for consistent height/padding/border.
 * Heights: 54 → 48 → 44 → 40 across breakpoints.
 */
export const InputTextField = withStyles({
  root: {
    width: "100%",
    "& label": {
      color: "#D4D4D4",
    },
    "& label.Mui-focused": {
      color: "#D4D4D4",
    },
    "& label:hover": {
      color: "#D4D4D4",
    },
    "& label.Mui-focused.Mui-error": {
      color: "#C01515",
    },
    "& .MuiOutlinedInput-root": {
      background: "#fff",
      border: "1px solid #D4D4D4",
      borderRadius: "8px",
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 500,
      paddingLeft: "14px",
      paddingRight: "14px",
      color: "#707070",
      lineHeight: "19px",
      height: "54px",
      boxSizing: "border-box",
      alignItems: "center",
      width: "100%",
      "@media (max-width:1199px)": {
        height: "48px",
      },
      "@media (max-width:899px)": {
        height: "44px",
      },
      "@media (max-width:599px)": {
        height: "40px",
      },
      "& .MuiOutlinedInput-input": {
        padding: "0 !important",
        height: "100%",
        boxSizing: "border-box",
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "19px",
        color: "#707070",
        "@media (max-width:1199px)": {
          fontSize: "16px",
        },
        "@media (max-width:899px)": {
          fontSize: "16px",
          lineHeight: "20px",
        },
        "@media (max-width:599px)": {
          fontSize: "14px",
          lineHeight: "18px",
        },
      },
      "&.MuiInputBase-multiline": {
        height: "auto",
        minHeight: "120px",
        alignItems: "flex-start",
        paddingTop: "12px",
        paddingBottom: "12px",
        "& .MuiOutlinedInput-input": {
          height: "auto",
          padding: "0 !important",
        },
      },
      "& .MuiInputAdornment-root": {
        margin: 0,
        height: "100%",
        maxHeight: "none",
      },
      "& .MuiIconButton-root": {
        padding: "4px",
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
      "& .MuiSvgIcon-root": {
        fill: "#373737",
        width: "22px",
        height: "22px",
      },
      "&.Mui-focused fieldset": {
        border: 0,
      },
      "&.Mui-disabled": {
        padding: "0 14px",
        background: "#F7F7F7",
        borderRadius: "8px",
        border: "1px solid #D4D4D4",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontFamily: "'Montserrat',sans-serif",
      color: "#C01515",
      fontSize: "14px",
      fontWeight: 500,
      margin: "4px 0 0",
      lineHeight: "19px",
      padding: "0px",
    },
    "& input.internal-autofill-selected": {
      backgroundColor: "none",
    },
  },
})(TextField);

export const InputSearchField = withStyles({
  root: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      background: "#fff",
      border: "1px solid #405cfb",
      borderRadius: "10px",
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: "500",
      padding: "0 0 0 14px",
      color: "#373737",
      lineHeight: "24px",
      height: "54px",
      boxSizing: "border-box",
      alignItems: "center",
      width: "100%",
      "@media (max-width:1199px)": {
        height: "48px",
      },
      "@media (max-width:899px)": {
        height: "44px",
      },
      "@media (max-width:599px)": {
        height: "40px",
      },
      "& .MuiOutlinedInput-input": {
        padding: "0 !important",
        height: "100%",
        boxSizing: "border-box",
        fontSize: "16px",
      },
      "&.Mui-focused fieldset": {
        border: 0,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
})(TextField);
